import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BusinessLoanModule } from '../business-loan/business-loan.module';
import { DialogConfirmComponent } from './dialog-confirm/dialog-confirm.component';
import { ButtonComponent } from '../business-loan/button/button.component';
import { DialogInfoComponent } from './dialog-info/dialog-info.component';

@NgModule({
    declarations: [DialogConfirmComponent, DialogInfoComponent],
    exports: [DialogConfirmComponent, DialogInfoComponent],
    imports: [CommonModule, BusinessLoanModule, ButtonComponent],
})
export class DialogModule { }
